(() => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-header-nav]');
  const backdrop = document.querySelector('[data-nav-backdrop]');
  const mobileNavQuery = window.matchMedia('(max-width: 749px)');
  const navHomeParent = nav?.parentElement || null;
  const navHomeNext = nav?.nextElementSibling || null;

  const syncNavHost = () => {
    if (!nav || !navHomeParent) return;
    if (mobileNavQuery.matches) {
      // Detach from the fixed header so the drawer is truly viewport-relative.
      if (nav.parentElement !== document.body) document.body.appendChild(nav);
      if (backdrop && backdrop.parentElement !== document.body) {
        document.body.appendChild(backdrop);
      }
    } else if (nav.parentElement !== navHomeParent) {
      if (navHomeNext && navHomeNext.parentElement === navHomeParent) {
        navHomeParent.insertBefore(nav, navHomeNext);
      } else {
        navHomeParent.appendChild(nav);
      }
      if (backdrop && backdrop.parentElement !== document.body) {
        document.body.appendChild(backdrop);
      }
    }
  };

  const setDrawerOpen = (open) => {
    if (!nav || !toggle) return;
    syncNavHost();
    const shouldOpen = Boolean(open) && mobileNavQuery.matches;

    // Move focus out before hiding/inerting the drawer to avoid aria-hidden warnings.
    if (!shouldOpen && nav.contains(document.activeElement)) {
      toggle.focus();
    }

    nav.classList.toggle('is-open', shouldOpen);
    toggle.classList.toggle('is-open', shouldOpen);
    toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    toggle.setAttribute('aria-label', shouldOpen ? 'Close' : 'Menu');
    document.body.classList.toggle('nav-drawer-open', shouldOpen);
    if (backdrop) backdrop.hidden = !shouldOpen;
    if (mobileNavQuery.matches) {
      nav.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
      if ('inert' in nav) nav.inert = !shouldOpen;
    } else {
      nav.removeAttribute('aria-hidden');
      if ('inert' in nav) nav.inert = false;
    }
    if (shouldOpen) {
      nav.querySelector('[data-nav-close]')?.focus();
    }
  };

  // Keep the off-canvas drawer non-interactive until opened on mobile.
  setDrawerOpen(false);

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      setDrawerOpen(!nav.classList.contains('is-open'));
    });

    nav.querySelectorAll('[data-nav-close]').forEach((button) => {
      button.addEventListener('click', () => setDrawerOpen(false));
    });

    nav.querySelectorAll('.header-nav__list a').forEach((link) => {
      link.addEventListener('click', () => setDrawerOpen(false));
    });

    backdrop?.addEventListener('click', () => setDrawerOpen(false));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && nav.classList.contains('is-open')) {
        setDrawerOpen(false);
      }
    });

    const handleViewportChange = () => {
      syncNavHost();
      if (!mobileNavQuery.matches) setDrawerOpen(false);
    };

    if (typeof mobileNavQuery.addEventListener === 'function') {
      mobileNavQuery.addEventListener('change', handleViewportChange);
    } else if (typeof mobileNavQuery.addListener === 'function') {
      mobileNavQuery.addListener(handleViewportChange);
    }
  }

  document.querySelectorAll('[data-faq-accordion]').forEach((accordion) => {
    accordion.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-faq-toggle]');
      if (!toggle || !accordion.contains(toggle)) return;

      const item = toggle.closest('.faq-section__item');
      const panel = item?.querySelector('.faq-section__answer');
      if (!item || !panel) return;

      const willOpen = !item.classList.contains('is-open');

      accordion.querySelectorAll('.faq-section__item.is-open').forEach((openItem) => {
        if (openItem === item) return;
        openItem.classList.remove('is-open');
        const openToggle = openItem.querySelector('[data-faq-toggle]');
        const openPanel = openItem.querySelector('.faq-section__answer');
        if (openToggle) openToggle.setAttribute('aria-expanded', 'false');
        if (openPanel) openPanel.hidden = true;
      });

      item.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      panel.hidden = !willOpen;
    });
  });

})();

// CLIENT IMAGE
(() => {
  const setImageSource = (node, src, alt) => {
    if (!node || !src) return;

    // Find the existing image or use the node itself
    const img = node.tagName === "IMG" ? node : node.querySelector("img");

    if (!img) return;

    img.src = src;
    img.alt = alt || "";
  };

  document.querySelectorAll("[data-client-results]").forEach((section) => {
    const quoteEl = section.querySelector("[data-results-quote]");
    const attributionEl = section.querySelector("[data-results-attribution]");
    const photoNameEl = section.querySelector("[data-results-photo-name]");

    const photoFront = section.querySelector(".client-results__photo-img2");
    const photoBack = section.querySelector(".client-results__photo-img1");

    section.addEventListener("click", (event) => {
      const button = event.target.closest("[data-results-card]");

      if (!button || !section.contains(button)) return;

      section.querySelectorAll("[data-results-card]").forEach((card) => {
        card.setAttribute("aria-pressed", "false");
        card.closest(".client-results__card")?.classList.remove("is-selected");
      });

      button.setAttribute("aria-pressed", "true");
      button.closest(".client-results__card")?.classList.add("is-selected");

      const name = button.dataset.name || "";
      const age = button.dataset.age || "";
      const quote = button.dataset.quote || "";

      if (quoteEl) {
        quoteEl.textContent = `“${quote}”`;
      }

      if (attributionEl) {
        attributionEl.textContent = age ? `${name}, ${age}` : name;
      }

      if (photoNameEl) {
        photoNameEl.textContent = age ? `${name} age ${age}` : name;
      }

      // Shopify asset filenames: Lisa-1, Lisa-2, Holly-1, Holly-2, etc.
      const imageBaseUrl = "/cdn/shop/t/16/assets/";

      const imageFrontUrl = `${imageBaseUrl}${encodeURIComponent(name)}-1.svg`;
      const imageBackUrl = `${imageBaseUrl}${encodeURIComponent(name)}-2.svg`;

      setImageSource(photoFront, imageFrontUrl, name);
      setImageSource(photoBack, imageBackUrl, name);
    });
    // Select the first client automatically on page load
    const firstClient = section.querySelector("[data-results-card]");
    if (firstClient) {
      firstClient.click();
    }
  });
})();
